import { isInBrowser, inlineBtoa } from '@snapchat/metrics-utils';
import { sha256 } from '@snapchat/hash';

/**
 * Convert unsigned byte array into SHA-256 hashed string
 *
 * @param binaryPayload: Uint8Array unsigned byte array
 * @returns String. Base64 encoded SHA-256 Hash based on the byte array + `:<current_timestamp>`.
 */
export const computeWebAttestation = async (binaryPayload: Uint8Array): Promise<string> => {
  const hashString = await sha256(binaryPayload);
  const headerString = `${hashString}:${Date.now()}`;
  return isInBrowser() ? btoa(headerString) : inlineBtoa(headerString);
};
